export default "__VITE_ASSET__DrHQRuLd__"